import React, {Component} from 'react';
import {List} from "semantic-ui-react";

class ViewClerkRoomTemplateDetail extends Component {

    render() {
        return (
            <List>
                <List.Item>
                    <List.Icon name="caret right"/>
                    <List.Content>
                        <List.Header>
                            {(this.props.roomObject[0]) ? this.props.roomObject[0]['name'] : "Room"}
                        </List.Header>
                        {this.props.roomObject && this.props.roomObject[0].groups.map((group, i) => {
                            return (<List.List key={group.name + i}>
                                <List.Item>
                                    <List.Icon name="caret right"/>
                                    <List.Content>
                                        <List.Header>
                                            {group.name}
                                        </List.Header>
                                        {group['items'] && group['items'].map((item, j) => {
                                            return (
                                                <List.List key={item + j}>
                                                    <List.Item>
                                                        <List.Icon name="caret right"/>
                                                        <List.Content>
                                                            <List.Header>
                                                                {item.name}
                                                            </List.Header>
                                                        </List.Content>
                                                    </List.Item>
                                                </List.List>
                                            )
                                        })}
                                    </List.Content>
                                </List.Item>
                            </List.List>)
                        })
                        }
                    </List.Content>
                </List.Item>
            </List>
        )
    }
}

export default ViewClerkRoomTemplateDetail;


// WEBPACK FOOTER //
// ./src/views/report/templates/clerk/room_template_detail.js